import React, { memo } from 'react';
import {
  Timer,
  VisualNumber,
  TitleContainer,
  Title,
  Description,
  ContentContainer,
  Messages,
  ErrorMessage,
  Media,
  AnswerContainer
} from 'app/pages/Survey/Subject/elements';
import Answer from './Answer';

function DigitSlide() {
  return (
    <>
      <Timer />
      <VisualNumber />
      <TitleContainer>
        <Title />
        <Description />
      </TitleContainer>
      <ContentContainer>
        <Messages>
          <ErrorMessage />
        </Messages>
        <Media />
        <AnswerContainer>
          <Answer />
        </AnswerContainer>
      </ContentContainer>
    </>
  );
}

export default memo(DigitSlide);
